import buttonSlice from "./features/Button/buttonSlice";
import KIMSlice from "./features/KIM_info/KIMSlice";
const rootReducer = {
    button: buttonSlice,
    kim:KIMSlice,
}

export default rootReducer;